import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import StarRatings from "react-star-ratings";
import Moment from "react-moment";
import ContentLoader from "react-content-loader";
import Sidebar from "../../components/Sidebar/Sidebar";
import { withRouter } from "react-router-dom";
import { Drawer } from "@material-ui/core";

import "./product.css";
import SideCard from "./SideCard";
import TestSlider from "../../components/test-slider/Slider";
import ReviewSection from "./ReviewSection";
import * as dropdowns from "./Dropdown";
import { BsBoxArrowUpRight, BsArrowRight } from "react-icons/bs";
import { Rating, ReviewRow } from "./RatingAndReviews";
import {
  CarouselProvider,
  DotGroup,
  ImageWithZoom,
  Slide,
  Slider,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { cartAdd } from "../../actions/cart";
import { retreiveBySlug } from "../../actions/products";
import { retreiveBySingleBrand } from "../../actions/brand";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import {
  getSubCategory,
  getChildCategory,
  getCategoriesForProduct,
} from "../../actions/categories";
import { randomProducts } from "../../actions/products";
import { validateEasypost } from "../../actions/easypost";
import { getProductAffirmIntreset } from "../../actions/affirm";

// custome components

const SidebarOpener = (props) => {
  return (
    <>
      <div onClick={props.sideOpenerBtn} className="sidebar-opener mt-2">
        <span className="sideOpener-lable">{props.sideOpenerLable}</span>
        <button className="selectedText-btn" type="button">
          {props.sideOpenerText}
        </button>
        {props.children}
        <div className="sidebarOpener-arrow">
          <i className="fa fa-angle-right"></i>
        </div>
      </div>
    </>
  );
};

const CollapBtn = (props) => {
  const [collapOn, setCollap] = useState(false);
  const btnCli = () => {
    setCollap(!collapOn);
  };
  return (
    <>
      <button
        onClick={btnCli}
        className="btn pl-1 collapsed py-md-2 collapserBtn"
        type="button"
        data-toggle="collapse"
        data-target={props.dataTarget}
        aria-expanded="false"
        aria-controls={props.ariaControls}
      >
        {props.btnText}
        <span className={collapOn ? "rotateAngle180" : "rotateAngle0"}>
          <i className="fa fa-angle-down" />
        </span>
      </button>
    </>
  );
};

class SingleBlog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      colorsList: ["Green", "Blue", "Red", "yellow"],
      sizeList: ["45' x 43'", "5' x 1'", "76' x 7'", "1' x 21'"],
      product: null,
      showIndex: false,
      showBullets: true,
      infinite: true,
      showThumbnails: true,
      showFullscreenButton: true,
      showGalleryFullscreenButton: true,
      showPlayButton: true,
      showGalleryPlayButton: true,
      showNav: false,
      isRTL: false,
      slideDuration: 400,
      slideInterval: 5000,
      slideOnThumbnailOver: false,
      thumbnailPosition: "bottom",
      showVideo: {},
      images: [],
      quantity: 1,
      products: [],
      brand: "",
      prevSlug: "",
      preSlugNo: true,
      orderColor: "",
      orderPrice: 0,
      productInfo: "",
      brandId: "",
      location: "",
      apicheck: 0,
      easypostObj: "",
      subCategory: null,
      childCategory: null,
      apiCall: true,
      reviews: null,
      affirm: null,
      productGrouping: [],
      loading: true,
      brandSlug: "",
      borderAdd: false,
      moreText: "See More",
      more: false,
      productCount: 1,
      collapOn: false,
      productNumbersOpen: false,
      sidebar1open: false,
      sidebar2open: false,
      sidebar3open: false,
      sidebar4open: false,
      sidebar5open: false,
      configuration: {},
      colorText: "Blue",
      size: "12' x 43'",
      selectedAttribute: "",
      pictureChecker: true,
      groupingConfiguration: {},
      duplicateAttributes: [],
      groupedAttributes: [],
      selectedButton: "",
      imgIndx: "",
      testBorder: false,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    const slug = window.location.toString().split("product/")[1].split("?")[0];
    const categoryIdentifier = this.props.location.search.substring(1);
    this.fetchData(slug, categoryIdentifier);
    this.setState({ prevSlug: slug });
    // this.fetchData(slug);

    if (this.state.prevSlug !== slug) {
      window.scrollTo(0, 0);
      this.fetchData(slug, categoryIdentifier);
      this.setState({ prevSlug: slug, preSlugNo: false });
    }
  }
  componentWillReceiveProps(nextProps) {
    const slug = window.location.toString().split("product/")[1].split("?")[0];
    const categoryIdentifier = this.props.location.search.substring(1);

    this.fetchData(slug, categoryIdentifier);
    if (
      this.props.match.params.slug !==
      window.location.toString().split("product/")[1].split("?")[0]
    ) {
      window.scrollTo(0, 0);
      if (this.props.history.action === "POP") {
        this.props.history.goBack();
      }
    }
  }

  fetchData = async (slug, categoryIdentifier) => {
    if (this.state.prevSlug !== slug) {
      await this.setState({ apiCall: true });
    }

    window.scrollTo(0, 0);
    if (this.state.apiCall) {
      this.setState({ apiCall: false });
      const res = await this.props.retreiveBySlug(slug, categoryIdentifier);
      console.log(res);
      this.setState({ configuration: res.product[0].configuration[0] });
      this.setState({ duplicateAttributes: res.filterd[0].grouping });
      if (this.state.configuration) {
        this.state.configuration.categoryConfiguration[0].categoryConfigurationDetail.map(
          (item) => {
            if (item.outputField === "pictures") {
              this.setState({ pictureChecker: true });
            }
          }
        );
      }
      if (this.state.duplicateAttributes) {
        let dupId = "";
        let unique = [];
        let tempArr = [];

        this.state.duplicateAttributes.map((item, index) => {
          item.attribute.map((item1) => {
            tempArr.push(item1);
          });
        });
        console.log(tempArr);

        tempArr.map((item, index) => {
          dupId = item.text;

          tempArr.map((item1) => {
            if (
              dupId === item1.text &&
              item1.attributeId === "5f7709258d049b1b5897c3fd"
            ) {
              unique.push(item1.text);
            }
          });
        });
        console.log(unique);
      }

      this.setState({
        product: res.product[0],
        productGrouping: res.product[0].grouping,
        reviews: res.reviews,
        loading: false,
        groupedAttributes: res.groupedAttribute,
      });

      let testProduct = this.state.product;
      testProduct.grouping.map((item) => {
        this.state.groupedAttributes.map((item2) => {
          item2 &&
            item2.map((item3) => {
              if (item3._id === item._id) {
                let tempArr = [];
                item3.attribute.map((item4) => {
                  if (item4.attributeId !== "5f7709258d049b1b5897c3fd") {
                    tempArr.push(item4);
                  }
                });
                item.attribute = tempArr;
              }
            });
        });
      });
      console.log(testProduct);

      let ArrForAttr = [];
      res.groupedAttribute.map((item) => {
        item &&
          item.map((item2) => {
            if (item2._id === this.state.product._id) {
              item.map((item3) => {
                item3.attribute.map((item4) => {
                  if (item4.attributeId !== "5f7709258d049b1b5897c3fd") {
                    ArrForAttr.push(item4);
                  }
                });
              });

              let testAttribute = this.state.product;
              testAttribute.attribute = ArrForAttr;
              this.setState({
                product: testAttribute,
              });
            }
          });
      });

      if (res.product[0]) {
        const childCategory = await this.props.getChildCategory(
          res.product[0].category
        );
        if (childCategory) {
          const subCategory = await this.props.getSubCategory(
            childCategory.data.categoryId
          );
          if (subCategory) {
            this.setState({
              subCategory: subCategory.data,
              childCategory: childCategory.data,
            });
          }
        } else {
          const subCategory = await this.props.getSubCategory(
            res.product[0].category
          );
          if (subCategory) {
            this.setState({
              subCategory: subCategory.data,
              childCategory: subCategory.data,
            });
          }
        }
      }
      const images = [];
      // res.product[0].images.forEach((e) => {
      //   images.push({
      //     original: e,
      //     thumbnail: e,
      //   });
      // });
      images.push({
        original: res.product[0].mainImage,
        thumbnail: res.product[0].mainImage,
      });
      this.setState({ images: images });
      const products = await this.props.randomProducts();
      // const productsArr = [];
      // products &&
      //   products.data.forEach(async (__element) => {
      //     productsArr.push(__element);
      //   });
      await this.setState({ products: products });
      // const brand = await this.props.retreiveBySingleBrand(
      //   res.product[0].brand
      // );
      if (res.product[0].brandinfo.length > 0) {
        var location = localStorage.getItem("location");
        var brandId = res.product[0].brandinfo[0]._id;
        var productinfo = res;
        this.setState({
          location: JSON.parse(location),
          brandId: brandId,
          productInfo: productinfo,
        });
        if (this.state.apicheck === 0 && productinfo.price < 49) {
          this.setState({ apicheck: 1 });
          this._validateEasypost();
        }
      }
      this.setState({
        brand:
          res.product[0].brandinfo && res.product[0].brandinfo[0].firstName,
        brandSlug: res.product[0].brandinfo && res.product[0].brandinfo[0].slug,
      });
    }
  };
  // events functions

  compatibleProductSidebar = (test, test1) => {
    if (test1) {
      this.setState({
        [`sidebar${test1}open`]: true,
      });
    }
    document.body.style.overflow = "hidden";
  };

  CloseSidebar = (closeTest) => {
    // let abTest = [`sidebar${closeTest}open`];
    if (closeTest) {
      this.setState({
        [`sidebar${closeTest}open`]: false,
      });
    }
    if (closeTest == 1) {
      document.body.style.overflow = "auto";
    }
  };

  togglePNumbers = () => {
    this.setState({
      productNumbersOpen: !this.state.productNumbersOpen,
    });
  };

  btnCli = () => {
    this.setState({
      collapOn: !this.state.collapOn,
    });
  };

  seeMoredetails = () => {
    this.setState({
      more: !this.state.more,
      moreText: !this.state.moreText,
    });
  };

  handleSecondaryAttr = (item) => {
    console.log(item);
  };

  toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.type === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ rightSidebar: open });
  };

  _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "B" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      toast(`Product added to wishlist`, { containerId: "B" });
    }
  };

  _addToCart = async (item) => {
    const data = {
      item: item,
      quantity: this.state.quantity,
      color: this.state.orderColor,
      colorPrice: this.state.orderPrice,
      selectedAttribute: this.state.selectedAttribute,
    };
    const cartAdd = await this.props.cartAdd(data);
    if (cartAdd) {
      toast(`Product added in cart`, { containerId: "B" });
    }
  };
  _getSlug = (slug) => {
    this.setState({ prevSlug: slug, loading: true });
  };
  setOrderColor = (e, color) => {
    e.preventDefault();
    this.setState({ orderColor: color });
  };
  setOrderPrice = (e, price) => {
    e.preventDefault();
    this.setState({ orderPrice: price });
  };
  quantitySetter = (quant) => {
    this.setState({ quantity: quant });
  };

  handleAttributeCustom = (productItem, index) => {
    this.setState({
      selectedButton: index,
    });
    console.log(productItem);
    console.log(this.state.productGrouping);
    console.log(productItem._id);
    this.state.productGrouping.map((item) => {
      if (item._id === productItem.id) {
        console.log(item);
        let arrForGrouping = [];
        this.state.groupedAttributes.map((item2) => {
          item2.map((item3) => {
            if (item._id === item3._id) {
              item2.map((item4) => {
                item4.attribute.map((item5) => {
                  if (item5.attributeId !== "5f7709258d049b1b5897c3fd") {
                    arrForGrouping.push({ id: item._id, ...item5 });
                  }
                });
              });
            }
          });
        });
        let arrForGroupItem = item;

        arrForGroupItem.attribute = arrForGrouping;
        console.log(arrForGroupItem);
        this.setState({
          product: arrForGroupItem,
        });
      }
    });
    this.setState({
      selectedAttribute: productItem.text,
    });
  };
  changeProduct = (product1, index) => {
    this.setState({
      selectedButton: "",
      imgIndx: index,
      testBorder: !this.state.testBorder,
    });

    let testattr = {};
    let arrAtty = [];
    product1 &&
      product1.map((item) => {
        item.attribute.map((item2) => {
          if (item2.attributeId !== "5f7709258d049b1b5897c3fd") {
            arrAtty.push({ id: item._id, ...item2 });
          }
        });
      });
    this.state.productGrouping &&
      this.state.productGrouping.map((item) => {
        if (item && product1 && item._id === product1[0]._id) {
          testattr = item;
          testattr.attribute = arrAtty;

          this.setState({ product: testattr }, () => {});
        }
      });
  };
  _validateEasypost = async () => {
    const { location, brandId, productInfo } = this.state;
    // let formData = new FormData();
    // formData.append("location", location);
    // formData.append("brandId", brandId);
    // formData.append("productInfo", productInfo);
    const formData = {
      location: location,
      brandId: brandId,
      productInfo: productInfo,
    };

    const res = await this.props.validateEasypost(formData);

    if (res) {
      this.setState({
        easypostObj: res,
      });
      // localStorage.setItem("zipcode", JSON.stringify(res.texjar));
    } else if (res && res.status === false) {
      this.setState({ texjarMessage: false });
    }
    setTimeout(() => {
      this.setState({ texjarMessage: null });
    }, 3000);
  };

  render() {
    const {
      product,
      images,
      productGrouping,
      orderPrice,
      childCategory,
      subCategory,
      products,
      reviews,
      loading,
      configuration,
      selectedAttribute,
      groupedAttributes,
    } = this.state;
    const slideImages = [];
    //here lies the hope and dreams

    // product &&
    //   product.images.forEach((e) => {
    //     slideImages.push({
    //       original: e,
    //       thumbnail: e,
    //     });
    //   });
    if (product && product.mainImage) {
      slideImages.push({
        original: product.mainImage,
        thumbnail: product.mainImage,
      });
    }
    return (
      <Fragment>
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />
        <div
          className="product1-hero max-1600 wrapper-90 max-1600"
          ref={(el) => (this.instance = el)}
        >
          {product && product !== null && product !== undefined && (
            <BreadCrumb
              title={` ${
                subCategory && subCategory !== null && subCategory.name
              } / ${
                childCategory && childCategory !== null && childCategory.name
              } / SKU: ${product && product.sku}`}
            />
          )}
          <div className="container-fluid px-0 pt-3">
            <div className="smallScreen-productDetail">
              <div className="product1-details-right">
                <div className="product1-detail-heading">
                  <h2>{product && product.title}</h2>
                </div>
              </div>
              <div className="product1-shop-link">
                <span>
                  See More from &nbsp;
                  <Link to={`/brand/${this.state.brandSlug}`}>
                    {this.state.brand && this.state.brand}
                  </Link>
                  &nbsp; Shop
                </span>
              </div>
              <div className="product1-shop-link TESTING">
                <br />
                {product && product.sku ? (
                  <span className="product1-rating-reviews">
                    Sku :{product && product.sku}
                  </span>
                ) : null}
              </div>

              <div className="product1-rating-reviews">
                <ul>
                  <StarRatings
                    rating={
                      product && product.reviews
                        ? product.reviews / product.reviewCount
                        : 0
                    }
                    starDimension="20px"
                    starSpacing="2px"
                    starRatedColor="gold"
                  />
                  <span>{product && product.reviewCount}</span>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 pl-md-0 singleProductMain-img">
                <div className="product1-left-side">
                  {loading ? (
                    <ContentLoader
                      speed={2}
                      width={800}
                      height={800}
                      viewBox="0 0 800 800"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <rect
                        x="10"
                        y="0"
                        rx="0"
                        ry="0"
                        width="578"
                        height="669"
                      />
                      <rect
                        x="10"
                        y="686"
                        rx="0"
                        ry="0"
                        width="96"
                        height="95"
                      />
                      <rect
                        x="130"
                        y="685"
                        rx="0"
                        ry="0"
                        width="96"
                        height="95"
                      />
                      <rect
                        x="488"
                        y="683"
                        rx="0"
                        ry="0"
                        width="96"
                        height="95"
                      />
                      <rect
                        x="250"
                        y="685"
                        rx="0"
                        ry="0"
                        width="96"
                        height="95"
                      />
                      <rect
                        x="368"
                        y="683"
                        rx="0"
                        ry="0"
                        width="96"
                        height="95"
                      />
                    </ContentLoader>
                  ) : (
                    <ImageGallery
                      ref={(i) => (this._imageGallery = i)}
                      lazyLoad={false}
                      // onClick={this._onImageClick.bind(this)}
                      onImageLoad={this._onImageLoad}
                      // onSlide={this._onSlide.bind(this)}
                      // onPause={this._onPause.bind(this)}
                      // onScreenChange={this._onScreenChange.bind(this)}
                      // onPlay={this._onPlay.bind(this)}
                      infinite={this.state.infinite}
                      showBullets={this.state.showBullets}
                      showFullscreenButton={
                        this.state.showFullscreenButton &&
                        this.state.showGalleryFullscreenButton
                      }
                      showPlayButton={
                        this.state.showPlayButton &&
                        this.state.showGalleryPlayButton
                      }
                      showThumbnails={this.state.thumbnailPosition}
                      showIndex={this.state.showIndex}
                      showNav={this.state.showNav}
                      isRTL={this.state.isRTL}
                      thumbnailPosition={this.state.thumbnailPosition}
                      slideDuration={parseInt(this.state.slideDuration)}
                      slideInterval={parseInt(this.state.slideInterval)}
                      slideOnThumbnailOver={this.state.slideOnThumbnailOver}
                      autoPlay={"true"}
                      additionalClass="app-image-gallery"
                      items={slideImages && slideImages}
                    />
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="product1-right-side">
                  <div className="desktopScreen-productDetail">
                    <div className="product1-details-right">
                      <div className="product1-detail-heading">
                        {loading ? (
                          <ContentLoader
                            speed={1}
                            width={340}
                            height={84}
                            viewBox="0 0 340 84"
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                          >
                            <rect
                              x="0"
                              y="0"
                              rx="3"
                              ry="3"
                              width="67"
                              height="11"
                            />
                            <rect
                              x="76"
                              y="0"
                              rx="3"
                              ry="3"
                              width="140"
                              height="11"
                            />
                            <rect
                              x="127"
                              y="48"
                              rx="3"
                              ry="3"
                              width="53"
                              height="11"
                            />
                            <rect
                              x="187"
                              y="48"
                              rx="3"
                              ry="3"
                              width="72"
                              height="11"
                            />
                            <rect
                              x="18"
                              y="48"
                              rx="3"
                              ry="3"
                              width="100"
                              height="11"
                            />
                            <rect
                              x="0"
                              y="71"
                              rx="3"
                              ry="3"
                              width="37"
                              height="11"
                            />
                            <rect
                              x="18"
                              y="23"
                              rx="3"
                              ry="3"
                              width="140"
                              height="11"
                            />
                            <rect
                              x="166"
                              y="23"
                              rx="3"
                              ry="3"
                              width="173"
                              height="11"
                            />
                          </ContentLoader>
                        ) : (
                          <h2>{product && product.title}</h2>
                        )}
                      </div>
                    </div>

                    <div className="product1-shop-link">
                      {loading ? (
                        <ContentLoader
                          speed={1}
                          width={340}
                          height={84}
                          viewBox="0 0 340 84"
                          backgroundColor="#f3f3f3"
                          foregroundColor="#ecebeb"
                        >
                          <rect
                            x="0"
                            y="0"
                            rx="3"
                            ry="3"
                            width="67"
                            height="11"
                          />
                          <rect
                            x="76"
                            y="0"
                            rx="3"
                            ry="3"
                            width="140"
                            height="11"
                          />
                          <rect
                            x="127"
                            y="48"
                            rx="3"
                            ry="3"
                            width="53"
                            height="11"
                          />
                          <rect
                            x="187"
                            y="48"
                            rx="3"
                            ry="3"
                            width="72"
                            height="11"
                          />
                          <rect
                            x="18"
                            y="48"
                            rx="3"
                            ry="3"
                            width="100"
                            height="11"
                          />
                          <rect
                            x="0"
                            y="71"
                            rx="3"
                            ry="3"
                            width="37"
                            height="11"
                          />
                          <rect
                            x="18"
                            y="23"
                            rx="3"
                            ry="3"
                            width="140"
                            height="11"
                          />
                          <rect
                            x="166"
                            y="23"
                            rx="3"
                            ry="3"
                            width="173"
                            height="11"
                          />
                        </ContentLoader>
                      ) : (
                        <Fragment>
                          <span>
                            See More from &nbsp;
                            <Link to={`/brand/${this.state.brandSlug}`}>
                              {this.state.brand && this.state.brand}
                            </Link>
                            &nbsp; Shop
                          </span>
                          <br />
                          {product && product.sku ? (
                            <span>
                              Sku : &nbsp;
                              {product && product.sku}
                            </span>
                          ) : null}
                          <div className="product1-rating-reviews">
                            <ul>
                              <StarRatings
                                rating={
                                  product && product.reviews
                                    ? product.reviews / product.reviewCount
                                    : 0
                                }
                                starDimension="20px"
                                starSpacing="2px"
                                starRatedColor="gold"
                              />
                              <span>{product && product.reviewCount}</span>
                            </ul>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  </div>
                  {loading ? (
                    <ContentLoader
                      speed={1}
                      width={740}
                      height={704}
                      viewBox="0 0 740 704"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="67" height="11" />
                      <rect
                        x="76"
                        y="0"
                        rx="3"
                        ry="3"
                        width="140"
                        height="11"
                      />
                      <rect
                        x="127"
                        y="48"
                        rx="3"
                        ry="3"
                        width="53"
                        height="11"
                      />
                      <rect
                        x="187"
                        y="48"
                        rx="3"
                        ry="3"
                        width="72"
                        height="11"
                      />
                      <rect
                        x="18"
                        y="48"
                        rx="3"
                        ry="3"
                        width="100"
                        height="11"
                      />
                      <rect x="0" y="71" rx="3" ry="3" width="37" height="11" />
                      <rect
                        x="18"
                        y="23"
                        rx="3"
                        ry="3"
                        width="140"
                        height="11"
                      />
                      <rect
                        x="166"
                        y="23"
                        rx="3"
                        ry="3"
                        width="173"
                        height="11"
                      />
                      <rect x="1" y="94" rx="3" ry="3" width="67" height="11" />
                      <rect
                        x="77"
                        y="94"
                        rx="3"
                        ry="3"
                        width="140"
                        height="11"
                      />
                      <rect
                        x="128"
                        y="142"
                        rx="3"
                        ry="3"
                        width="53"
                        height="11"
                      />
                      <rect
                        x="188"
                        y="142"
                        rx="3"
                        ry="3"
                        width="72"
                        height="11"
                      />
                      <rect
                        x="19"
                        y="142"
                        rx="3"
                        ry="3"
                        width="100"
                        height="11"
                      />
                      <rect
                        x="1"
                        y="165"
                        rx="3"
                        ry="3"
                        width="37"
                        height="11"
                      />
                      <rect
                        x="19"
                        y="117"
                        rx="3"
                        ry="3"
                        width="140"
                        height="11"
                      />
                      <rect
                        x="167"
                        y="117"
                        rx="3"
                        ry="3"
                        width="173"
                        height="11"
                      />
                      <rect
                        x="5"
                        y="206"
                        rx="0"
                        ry="0"
                        width="594"
                        height="594"
                      />
                    </ContentLoader>
                  ) : (
                    <Fragment>
                      <div className="product-1-price">
                        <h3>
                          {product && orderPrice === 0
                            ? product.enableSale === true
                              ? Number(
                                  product.price * this.state.quantity -
                                    (product.price * product.saleDiscount) / 100
                                ).toFixed(2)
                              : Number(
                                  product.price * this.state.quantity
                                ).toFixed(2)
                            : null}
                          {product && orderPrice !== 0
                            ? product.enableSale === true
                              ? Number(
                                  orderPrice * this.state.quantity -
                                    (orderPrice * product.saleDiscount) / 100
                                ).toFixed(2)
                              : Number(
                                  orderPrice * this.state.quantity
                                ).toFixed(2)
                            : null}
                        </h3>
                        <del>
                          {product &&
                          product.enableSale === true &&
                          orderPrice === 0
                            ? "$" +
                              Number(
                                ((product.price * product.saleDiscount) / 100) *
                                  this.state.quantity
                              ).toFixed(2)
                            : null}
                          {product &&
                          product.enableSale === true &&
                          orderPrice !== 0
                            ? "$" +
                              Number(
                                ((orderPrice * product.saleDiscount) / 100) *
                                  this.state.quantity
                              ).toFixed(2)
                            : null}
                        </del>
                        <span>
                          {product && product.enableSale === true
                            ? product.saleDiscount + "% Off"
                            : null}
                        </span>
                      </div>
                      <div className="product1-shiping-date">
                        {product && product.price > 49 ? (
                          <span>
                            <span>Free Shipping on orders over $49.00</span>
                            <p className="m-0">Ships Today </p>
                          </span>
                        ) : (
                          <span>
                            {this.state.easypostObj &&
                            this.state.easypostObj.rates.length !== 0 ? (
                              <span>
                                <span>You can get in next one to two day</span>
                                <p className="m-0">
                                  Shipping rate is&nbsp;
                                  {this.state.easypostObj &&
                                    this.state.easypostObj.rates.length !== 0 &&
                                    this.state.easypostObj.rates[0].rate}
                                </p>
                              </span>
                            ) : (
                              <span>Shipping Not Available In your Area</span>
                            )}
                          </span>
                        )}
                      </div>
                      <div className="product1-shop-link">
                        <p
                          className="affirm-as-low-as"
                          data-page-type="product"
                          data-amount={`${product && product.price * 100}`}
                        ></p>
                      </div>

                      <>
                        <div className="container">
                          <div className="row">
                            {groupedAttributes &&
                              groupedAttributes.map((item, index) => (
                                <>
                                  <div
                                    key={item && item._id}
                                    className={`
                                    colorOptions-imgs  ${
                                      this.state.imgIndx === index
                                        ? "bordered"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      this.changeProduct(item, index)
                                    }
                                  >
                                    {this.state.imgIndx === index ? (
                                      <div className="checkSvg">
                                        <svg
                                          className="check-icon"
                                          viewBox="0 0 28 28"
                                        >
                                          <path d="M19.6 8.2c-.5-.3-1.1-.2-1.4.3l-6 8.8-2.4-3.5c-.3-.5-.9-.6-1.4-.3-.5.3-.6.9-.3 1.4l3.2 4.7c.2.3.5.4.8.4s.6-.2.8-.4l6.8-10c.4-.5.3-1.1-.1-1.4z"></path>
                                        </svg>
                                      </div>
                                    ) : null}

                                    {/* <img
                                      src={item && item.images[0]}
                                      alt=""
                                      className="img-responsive"
                                      style={{
                                        width: "100%",
                                        cursor: "pointer",
                                        border: "1px solid rgb(197, 197, 197)",
                                        borderRadius: "7px",
                                        marginTop: "10px",
                                      }}
                                    /> */}
                                    <div className="colorOptions-img">
                                      <div
                                        style={{
                                          backgroundImage: `url(${
                                            item && item[0].mainImage
                                          })`,
                                          backgroundSize: "contain",
                                          height: "100%",
                                          backgroundRepeat: "no-repeat",
                                          backgroundPosition: "center",
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </>
                              ))}
                          </div>
                        </div>
                      </>

                      <div className="product1-size">
                        {configuration && configuration.status === true ? (
                          <div>
                            {/*  <div
                              className="row"
                              style={{
                                margin: "0",
                              }}
                            >
                              {this.state.pictureChecker ? (
                                productGrouping &&
                                Array.isArray(productGrouping) &&
                                productGrouping.map((item, index) => (
                                  <div
                                    key={index}
                                    className="col-lg-1 col-md-1 col-sm-1 col-2"
                                    style={{
                                      padding: "0px 2px",
                                      flex: "0 0 40px",
                                      width: "40px",
                                    }}
                                    onClick={() => {
                                      this.setState({ product: item });
                                    }}
                                  >
                                
                                    <div
                                      style={{
                                        height: "35px",
                                        border: "1px solid #e1e1e1",
                                        borderRadius: "7px",
                                        padding: "2px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          backgroundImage: `url(${
                                            item && item.mainImage
                                          })`,
                                          backgroundSize: "contain",
                                          height: "100%",
                                          backgroundRepeat: "no-repeat",
                                          backgroundPosition: "center",
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className=""></div>
                              )}
                            </div> */}
                            {configuration &&
                              configuration.categoryConfiguration[0].categoryConfigurationDetail.map(
                                (item1, index1) => (
                                  <>
                                    <h6
                                      className={`${
                                        index1 === 0 ? "d-none" : ""
                                      }`}
                                    >{`Select ${item1.title}`}</h6>
                                    <div
                                      className={`container ${
                                        index1 === 0 ? "d-none" : ""
                                      }`}
                                    >
                                      <div className="row">
                                        {product.attribute
                                          .slice(0, 3)
                                          .map((item, index) => (
                                            <React.Fragment>
                                              {item.attributeId ===
                                              item1.keyFieldId ? (
                                                <div
                                                  className={`col-md-6 px-0`}
                                                >
                                                  <div
                                                    className={
                                                      this.state
                                                        .selectedButton ===
                                                      index
                                                        ? "m-2 p-2 size-box-border c-pointer bordered"
                                                        : "m-2 p-2 size-box-border c-pointer "
                                                    }
                                                    onClick={() =>
                                                      this.handleAttributeCustom(
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <div>
                                                      <div className="p-2">
                                                        <div className="size-boxes d-flex c-pointer">
                                                          <button
                                                            className={`c-pointer no-border w-100  `}
                                                          >
                                                            {item.text}
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                // <ToggleButtonGroup
                                                //   value={selectedAttribute}
                                                // onChange={() =>
                                                //   this.handleAttributeCustom(item)
                                                // }
                                                //   aria-label="text alignment"
                                                //   className=" ml-1"
                                                // >
                                                //   <ToggleButton
                                                //     value={item.text}
                                                //     aria-label="left aligned"
                                                //     className=""
                                                //   >
                                                //     {item.text}
                                                //   </ToggleButton>
                                                // </ToggleButtonGroup>
                                                ""
                                              )}
                                            </React.Fragment>
                                          ))}
                                        <div className="col-md-6 px-0">
                                          <div
                                            className="m-2 p-2 size-box-border c-pointer"
                                            onClick={this.toggleDrawer(
                                              "anchor",
                                              true
                                            )}
                                          >
                                            <div>
                                              <div className="p-2">
                                                <div className="size-boxes d-flex c-pointer">
                                                  <button className="c-pointer no-border w-100">
                                                    <span className="default-color">
                                                      +
                                                      {product.attribute
                                                        .length - 3}
                                                    </span>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )
                              )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <Drawer
                        anchor={"right"}
                        open={this.state.rightSidebar}
                        onClose={this.toggleDrawer("right", false)}
                      >
                        <div className="productFilterSidebar">
                          <div className="sidebar-header">
                            <div
                              title="close"
                              className="closeSidebar"
                              onClick={this.toggleDrawer("right", false)}
                            >
                              <button
                                type="button"
                                className="close-sidebar-btn"
                              >
                                <svg
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="closeSide-icon"
                                  aria-hidden="true"
                                  data-hb-id="pl-icon"
                                >
                                  <path d="M15.4 14l3.3-3.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L14 12.6l-3.3-3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.3 3.3-3.3 3.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l3.3-3.3 3.3 3.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L15.4 14z"></path>
                                </svg>
                              </button>
                            </div>
                            <div className="sidebar-header-text">
                              <span>Select Rug Size </span>
                            </div>
                          </div>

                          <div>
                            {configuration &&
                              configuration.categoryConfiguration[0].categoryConfigurationDetail.map(
                                (item1) => (
                                  <>
                                    <div className="container">
                                      <div className="row">
                                        {product.attribute.map(
                                          (item, index) => (
                                            <React.Fragment>
                                              {item.attributeId ===
                                              item1.keyFieldId ? (
                                                <div className="col-md-12 px-0">
                                                  <div
                                                    className={
                                                      this.state
                                                        .selectedButton ===
                                                      index
                                                        ? "m-2 p-2 size-box-border c-pointer bordered"
                                                        : "m-2 p-2 size-box-border c-pointer "
                                                    }
                                                    onClick={() =>
                                                      this.handleAttributeCustom(
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <div>
                                                      <div className="p-2">
                                                        <div className="size-boxes d-flex c-pointer">
                                                          <button
                                                            className={`c-pointer no-border w-100  `}
                                                          >
                                                            {item.text}
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                // <ToggleButtonGroup
                                                //   value={selectedAttribute}
                                                // onChange={() =>
                                                //   this.handleAttributeCustom(item)
                                                // }
                                                //   aria-label="text alignment"
                                                //   className=" ml-1"
                                                // >
                                                //   <ToggleButton
                                                //     value={item.text}
                                                //     aria-label="left aligned"
                                                //     className=""
                                                //   >
                                                //     {item.text}
                                                //   </ToggleButton>
                                                // </ToggleButtonGroup>
                                                ""
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                        <div className="col-md-12">
                                          <strong>Total Price: $54.99</strong>
                                          <div className="save-btn bg-default text-center color-white">
                                            save
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )
                              )}
                          </div>
                        </div>
                      </Drawer>

                      <div className="product1-save-cart-btns">
                        <div className="selectNumberrOfProduct">
                          <button
                            onClick={this.togglePNumbers}
                            className="btn  productNumberTogglerBtn collapsed py-md-3"
                            type="button"
                          >
                            {this.state.productCount}
                            <span className="rotateAngle180 selectIcon">
                              <i className="fa fa-angle-down" />
                            </span>
                          </button>
                          <ul
                            className={
                              this.state.productNumbersOpen
                                ? "productNumberList"
                                : "d-none"
                            }
                          >
                            {this.state.productList.map((item) => (
                              <li
                                className="productNumberLi"
                                onClick={() => {
                                  this.setState({
                                    quantity: item,
                                    productCount: item,
                                    productNumbersOpen: false,
                                  });
                                }}
                              >
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>

                        <button
                          className="product1-save-btn f0"
                          onClick={() => {
                            this._addToWishlist(product && product);
                          }}
                        >
                          <i className="far fa-heart" />
                        </button>
                        <button
                          className="product1-cart-btn"
                          onClick={() => {
                            this._addToCart(product && product);
                          }}
                        >
                          <a href="#!" className="addToCart">
                            Add to Cart
                          </a>
                        </button>
                      </div>
                      <hr />

                      <div className="product1-view">
                        <div className="productview-content">
                          <div className="productview-heading">
                            <h3>Product Overview</h3>
                          </div>
                          <div className="productview-body">
                            <div className="card border-none">
                              <div
                                id="product-description"
                                className={
                                  this.state.borderAdd
                                    ? "collapse-heading borderAdd"
                                    : "collapse-heading"
                                }
                              >
                                <button
                                  onClick={this.btnCli}
                                  className="btn pl-1 collapsed py-md-2 collapserBtn"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#description-collapse"
                                  aria-expanded="false"
                                  aria-controls="description-collapse"
                                >
                                  Description
                                  <span
                                    className={
                                      this.state.collapOn
                                        ? "rotateAngle0"
                                        : "rotateAngle180"
                                    }
                                  >
                                    <i className="fa fa-angle-down" />
                                  </span>
                                </button>
                              </div>
                              <div
                                id="description-collapse"
                                className="collapse show"
                                aria-labelledby="product1description"
                                data-parent="#accordion"
                              >
                                <div className="card-body pl-0">
                                  <div className="description-body">
                                    <div
                                      className={
                                        this.state.more ? "moreText" : "lesText"
                                      }
                                    >
                                      <p>{product && product.description} </p>
                                    </div>
                                    {product &&
                                    product.description.length > 450 ? (
                                      <div
                                        onClick={this.seeMoredetails}
                                        className="dropSeeMore"
                                      >
                                        {this.state.moreText ? (
                                          <span className="seemoreLink">
                                            See More
                                          </span>
                                        ) : (
                                          <span className="seeLessLink">
                                            See Less
                                          </span>
                                        )}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <hr className="my-0" />
                            </div>
                            <div className="card border-none">
                              <div
                                id="product-weights-dimention"
                                className="collapse-heading"
                              >
                                <CollapBtn
                                  btnText="Weights & Dimensions"
                                  dataTarget="#weights-dimention-collapse"
                                  ariaControls="weights-dimention-collapse"
                                />
                              </div>
                              <div
                                id="weights-dimention-collapse"
                                className="collapse"
                                aria-labelledby="product1weights-dimention"
                                data-parent="#accordion"
                              >
                                <div className="card-body pl-0">
                                  <div className="weights-dimension-content">
                                    {product &&
                                      product.attributes &&
                                      product.attributes.map((e, index) =>
                                        e.attributeGroupId ===
                                        "5f76c1b98e07c124a8bf7890"
                                          ? product &&
                                            product.attribute &&
                                            product.attribute.map(
                                              (attrib, indx) =>
                                                attrib.attributeId === e.id ? (
                                                  <Fragment key={indx}>
                                                    {" "}
                                                    <Fragment>
                                                      <div className="product-weight d-flex">
                                                        <div className="overall-weight f1">
                                                          <p className="m-0 py-2">
                                                            {e.name}
                                                          </p>
                                                        </div>
                                                        <p className="m-0 py-2 f1">
                                                          {attrib.text}
                                                        </p>
                                                      </div>{" "}
                                                    </Fragment>
                                                  </Fragment>
                                                ) : null
                                            )
                                          : null
                                      )}
                                  </div>
                                </div>
                              </div>
                              <hr className="my-0" />
                            </div>
                            <div className="card border-none">
                              <div
                                id="product-spesification"
                                className="collapse-heading"
                              >
                                <CollapBtn
                                  btnText="Specifications"
                                  dataTarget="#spesification-collapse"
                                  ariaControls="spesification-collapse"
                                />
                              </div>
                              <div
                                id="spesification-collapse"
                                className="collapse"
                                aria-labelledby="product1spesification"
                                data-parent="#accordion"
                              >
                                <div className="card-body pl-0">
                                  <div className="spesification-content">
                                    {product &&
                                      product.attributes &&
                                      product.attributes.map((e, index) =>
                                        e.attributeGroupId ===
                                        "5f76c19e8e07c124a8bf788f"
                                          ? product &&
                                            product.attribute &&
                                            product.attribute.map(
                                              (attrib, indx) =>
                                                attrib.attributeId === e.id ? (
                                                  <Fragment key={indx}>
                                                    {" "}
                                                    <Fragment>
                                                      <div className="product-weight d-flex">
                                                        <div className="overall-weight f1">
                                                          <p className="m-0 py-2">
                                                            {e.name}
                                                          </p>
                                                        </div>
                                                        <p className="m-0 py-2 f1">
                                                          {attrib.text}
                                                        </p>
                                                      </div>{" "}
                                                    </Fragment>
                                                  </Fragment>
                                                ) : null
                                            )
                                          : null
                                      )}
                                  </div>
                                </div>
                              </div>
                              <hr className="my-0" />
                            </div>
                            <div className="card border-none">
                              <div
                                id="product-shiping-returns"
                                className="collapse-heading"
                              >
                                <CollapBtn
                                  btnText={`About ${
                                    this.state.brand && this.state.brand
                                  }`}
                                  dataTarget="#shiping-returns-collapse"
                                  ariaControls="shiping-returns-collapse"
                                />
                              </div>
                              <div
                                id="shiping-returns-collapse"
                                className="collapse"
                                aria-labelledby="product1shiping-returns"
                                data-parent="#accordion"
                              >
                                <div className="card-body pl-0">
                                  {product &&
                                  product.brands &&
                                  product.brands[0] ? (
                                    <img
                                      width="160px"
                                      alt={this.state.brand && this.state.brand}
                                      src={product.brands[0].storeLogo}
                                    />
                                  ) : null}
                                  <br />
                                  {product &&
                                    product.brands &&
                                    product.brands[0].storeMetaDescription}
                                </div>
                              </div>
                              <hr className="my-0" />
                            </div>
                            {/*LAST COLLPA*/}
                          </div>
                          {/*product view body*/}
                        </div>
                        {/*product viewcontent*/}
                      </div>
                      {/*product view*/}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {reviews && reviews.length !== 0 ? (
          <section
            className="container-fluid px-5"
            style={{ backgroundColor: "#fff" }}
          >
            <h2 className="cust-viwed">Reviews </h2>
            {reviews &&
              reviews.map((item, index) => (
                <Fragment key={index}>
                  <div className="product-customer-comments">
                    <div className="commenter-name">
                      <h4>{item.user.firstName}</h4>
                      <span>Customer</span>
                    </div>
                    <div className="commenter-comment-txt">
                      <header className="product-revies-header">
                        <ul className="product-commenter-reviews">
                          <StarRatings
                            rating={item && item.review}
                            starDimension="20px"
                            starSpacing="2px"
                            starRatedColor="gold"
                          />
                        </ul>
                        <div className="product-commenter-date">
                          <Moment format="D MMM, YYYY">{item.createdAt}</Moment>
                        </div>
                      </header>
                      <p>{item.feedback}</p>
                    </div>
                  </div>
                  <hr />
                </Fragment>
              ))}
          </section>
        ) : null}

        <div ref={(el) => (this.instance = el)}></div>
        <div className="container-fluid wrapper-90 max-1600 px-0">
          <div className="row mx-0 py-5">
            <SideCard
              cardSlidOpener={() =>
                this.compatibleProductSidebar(this.state.sidebar1open, 1)
              }
            />
          </div>
        </div>

        {this.state.sidebar1open ? (
          <div className="p1Sidebar">
            <Sidebar
              ref={this.setWrapperRef}
              className="sidebar-body h-100"
              CloseSidebar={() => this.CloseSidebar(1)}
            >
              <div className="sidebarBody-inner">
                <TestSlider />

                <div className="sidebar-title">
                  <h2 className="sidebarTitle-text">
                    All Season Down Alternative Comforter
                  </h2>
                </div>
                <div className="sideSeemore-byLink">
                  <span>
                    See More by{" "}
                    <Link to="#" target="_blank" className="compName">
                      The Twillery Co
                    </Link>
                  </span>
                </div>
                <div className="d-flex ">
                  <ul
                    /*  
                  👇👇👇👇👇
                  THIS IS CLICK EVENT FOR SECOND SIDEBAR INSIDE THE SIDEBAR  
                  onClick={() =>
                      this.compatibleProductSidebar(this.state.sidebar2open, 2)
                    }
                    */

                    className="sidebarReviews c-pointer d-flex flex-start align-center"
                  >
                    <div
                      className="reviewsStars d-flex"
                      style={{
                        backgroundImage:
                          "url('../assets/images/review-star.svg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "1rem",
                        width: "6rem",
                      }}
                    ></div>
                    <span className="ml-1 review-numbers">1234</span>
                  </ul>
                </div>
                <div className="my-4 sideToggler-card-price">
                  <span className="font-25">$12.34</span> &nbsp;
                  <s className="normal-font text-grey">$55.66</s>
                </div>

                <div className="selectNumberrOfProduct">
                  <button
                    onClick={this.togglePNumbers}
                    className="btn  productNumberTogglerBtn collapsed py-md-3"
                    type="button"
                  >
                    {this.state.productCount}
                    <span className="rotateAngle180 selectIcon">
                      <i className="fa fa-angle-down" />
                    </span>
                  </button>
                  <ul
                    className={
                      this.state.productNumbersOpen
                        ? "productNumberList"
                        : "d-none"
                    }
                  >
                    {this.state.productList.map((item) => (
                      <li
                        className="productNumberLi"
                        onClick={() => {
                          this.setState({
                            productCount: item,
                            productNumbersOpen: false,
                          });
                        }}
                      >
                        {" "}
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* 
              onClick={() =>
                  this.compatibleProductSidebar(this.sidebar3open, 3)
                }
              */}

                <SidebarOpener
                  ref={this.testRef}
                  sideOpenerBtn={() => {
                    this.compatibleProductSidebar(this.sidebar3open, 3);
                  }}
                  sideOpenerLable="Color (15)"
                  sideOpenerText={this.state.colorText}
                >
                  <div className="sidebarOpener-img">
                    <img
                      src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
                      width="100%"
                      alt=""
                    />
                  </div>
                </SidebarOpener>
                <SidebarOpener
                  sideOpenerBtn={() =>
                    this.compatibleProductSidebar(this.sidebar4open, 4)
                  }
                  sideOpenerLable={`Size (${this.state.sizeList.length})`}
                  sideOpenerText={this.state.size}
                >
                  <div className="sidebarOpener-img">
                    <img
                      src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
                      width="100%"
                      alt=""
                    />
                  </div>
                </SidebarOpener>

                <div className="d-flex mt-2">
                  <button
                    className="transform2On-hover box-shadow f1 d-flex sideSaveBtn align-center justify-center m-2"
                    type="button"
                  >
                    <i className="far fa-heart"></i>&nbsp;
                    <span>Save</span>
                  </button>
                  <button
                    className="default-hover transform2On-hover f2 bg-default Sidebar-addToCart-btn  m-2"
                    type="button"
                  >
                    <span className="color-white">Add to Cart</span>
                  </button>
                </div>

                {<dropdowns.DiskDropdown />}
                {<dropdowns.Dropdown dropdownLable="Weights & Dimensions" />}
                {<dropdowns.Dropdown dropdownLable="Specifications" />}
                {<dropdowns.Dropdown dropdownLable="About ProductName" />}

                <div className="mt-3">
                  <Link to="#" className="d-block">
                    <ul
                      onClick={() =>
                        this.compatibleProductSidebar(
                          this.state.sidebar2open,
                          2
                        )
                      }
                      className="sidebarReviews d-flex flex-start align-center"
                    >
                      <div
                        className="reviewsStars d-flex"
                        style={{
                          backgroundImage:
                            "url('../assets/images/review-star.svg')",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          height: "1rem ",
                          width: "6rem",
                        }}
                      ></div>
                      <span className="ml-1 review-numbers">1234</span>
                      <BsArrowRight className="ml-auto" />
                    </ul>
                  </Link>
                </div>

                <Link
                  to="#"
                  className=" underline-hovered underLined d-flex align-center justify-center my-5 seeSideDetails"
                  target="_blank"
                >
                  <span className="default-color">See Full Details </span>
                  &nbsp; <BsBoxArrowUpRight className="default-color" />
                </Link>
              </div>
            </Sidebar>
          </div>
        ) : null}
        {/* second sidebar */}
        {this.state.sidebar2open ? (
          <div className="p1Sidebar">
            <Sidebar
              className="h-100 scroll-y-auto"
              CloseSidebar={() => this.CloseSidebar(2)}
            >
              <div className="reviews-sidebarSlider">
                <h4 className="mb-2 cus-reviewPhoto-text">
                  Customer Photos 5+
                </h4>
                <TestSlider />
              </div>
              <div className="h-100 review-container">
                <ReviewSection />
              </div>
            </Sidebar>
          </div>
        ) : null}
        {/* third sidebar */}
        {this.state.sidebar3open ? (
          <div className="p1Sidebar">
            <Sidebar
              className="sidebar-body h-100"
              CloseSidebar={() => this.CloseSidebar(3)}
            >
              {this.state.colorsList.map((item) => {
                return (
                  <div
                    className="d-flex align-center colors-row"
                    onClick={() => {
                      this.CloseSidebar(3);
                      this.setState({ colorText: item });
                    }}
                  >
                    <div className="w-20 color-imgContainer">
                      <img
                        src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
                        width="100%"
                        alt=""
                      />
                    </div>
                    <div className="f2 colors-container">
                      <p className="m-0 colorsText">{item}</p>
                      <p className="m-0">$43.5</p>
                    </div>
                    <button className="color-selectBtn bg-default default-hover">
                      Select
                    </button>
                  </div>
                );
              })}
            </Sidebar>
          </div>
        ) : null}
        {/* fourth sidebar */}
        {this.state.sidebar4open ? (
          <div className="p1Sidebar">
            <Sidebar
              className="sidebar-body h-100"
              CloseSidebar={() => this.CloseSidebar(4)}
            >
              {this.state.sizeList.map((item) => {
                return (
                  <div
                    className="d-flex align-center colors-row"
                    onClick={() => {
                      this.CloseSidebar(4);
                      this.setState({ size: item });
                    }}
                  >
                    <div className="w-20 color-imgContainer">
                      <img
                        src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
                        width="100%"
                        alt=""
                      />
                    </div>
                    <div className="f2 colors-container">
                      <p className="m-0 colorsText">{item}</p>
                      <p className="m-0">$43.5</p>
                    </div>
                    <button className="color-selectBtn bg-default default-hover">
                      Select
                    </button>
                  </div>
                );
              })}
            </Sidebar>
          </div>
        ) : null}

        {/* RATING AND REVIEWS */}

        <div className="global-grey">
          <div className="wrapper-90 max-1600">
            <div className="review-header">
              <h4 className="py-3 mb-0 font-25 font-weight-700">
                Ratings & Reviews
              </h4>
              <p className="mb-3">
                Our
                <Link
                  className="underLined default-color"
                  target="_blank"
                  to="#"
                >
                  Community Guidelines
                </Link>
                help customers write honest reviews.
              </p>
            </div>
            <Rating />
            <div id="quistion" className="bg-white">
              <ReviewRow />
              <hr />
              <ReviewRow />
              <hr />
              <ReviewRow />
              <hr />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

retreiveBySlug.propTypes = {
  retreiveBySlug: PropTypes.func.isRequired,
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};
randomProducts.propTypes = {
  randomProducts: PropTypes.func.isRequired,
};
retreiveBySingleBrand.propTypes = {
  retreiveBySingleBrand: PropTypes.func.isRequired,
};
validateEasypost.propTypes = {
  validateEasypost: PropTypes.func.isRequired,
};
getSubCategory.propTypes = {
  getSubCategory: PropTypes.func.isRequired,
};
getChildCategory.propTypes = {
  getChildCategory: PropTypes.func.isRequired,
};
getProductAffirmIntreset.propTypes = {
  getProductAffirmIntreset: PropTypes.func.isRequired,
};
getCategoriesForProduct.propTypes = {
  getCategoriesForProduct: PropTypes.func.isRequired,
};

export default withRouter(
  connect(null, {
    cartAdd,
    retreiveBySlug,
    randomProducts,
    retreiveBySingleBrand,
    validateEasypost,
    getSubCategory,
    getChildCategory,
    getProductAffirmIntreset,
    getCategoriesForProduct,
  })(SingleBlog)
);
